import React from 'react'

const Footer2 = () => {
  return (
    <div className='bg-[#0a181b] text-[white] font-semibold text-[16px]'>Made with <span className='text-[#ff2e2e] text-[18px] animate-pulse'>&hearts;</span> by Manish Sharma</div>
  )
}

export default Footer2